import React, { ReactNode } from 'react';
import MarkdownRender from './MarkdownRender';
import { DictionaryContextType } from './context/DictionaryContextTypes';
import useDictionary from './context/useDictionary';
import { isProd } from '../utils/isProd';

interface RenderTextProps {
  textKey: string;
  isMarkdown?: boolean;
  context?: DictionaryContextType | undefined;
  childRenderer?: (child: ReactNode) => ReactNode;
}

const RenderText: React.FC<RenderTextProps> = (props) => {
  const { textKey, isMarkdown, context, childRenderer } = props;
  const { gT } = useDictionary();
  const dictionaryText = gT(textKey, context);
  const dictionaryArray = typeof dictionaryText !== 'string'
    ? dictionaryText : [ dictionaryText ];

  const getContent = (text: string) => {
    const content = isMarkdown ? <MarkdownRender text={text} /> : text;
    const prev = !!childRenderer ? childRenderer(content) : content;
    if (isProd) {
      return <span data-testid={textKey}>{prev}</span>;
    }
    return <span title={textKey} data-testid={textKey}>{prev}</span>;
  };

  return (
    <>
      {dictionaryArray.map((text) => (
        <React.Fragment key={text}>
          {getContent(text)}
        </React.Fragment>
      ))}
    </>
  );
};

export default RenderText;
